import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.select = this.element.matches("select") ? this.element : this.element.querySelector("select")
    this.change = this.change.bind(this)
    this.select.addEventListener("change", this.change)
  }

  disconnect() {
    this.select?.removeEventListener("change", this.change)
  }

  change(event) {
    if (!event.target.value) return

    const url = new URL("/financial_analysis/other_billing_and_inquiries/courier_recipient_city_code_change", window.location.origin)
    url.searchParams.set("courier_recipient_province_code", event.target.value)
    $.ajax(url.toString(), { dataType: "script" })
  }
}
